import { createContext } from 'react';
let UserContext = createContext();
export default UserContext;
